
export const HOST='https://app.cruzero.net/api/'